import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'bolContainerTypeSelect',
    'bolContainerTypeWrapper',
    'bolField',
    'bookingContainerTypeSelect',
    'bookingContainerTypeWrapper',
    'bookingField',
  ]

  // Pickup Empty Container
  async updateBookingContainerTypeField () {
    if(!this.hasBookingFieldTarget) return;

    const bookingId = this.bookingFieldTarget.value
    if (!bookingId) {
      this.clearBookingContainerTypeField()
      return
    }

    if(!this.hasBookingContainerTypeSelectTarget) return;

    // If there is a booking id,
    // 1. clear the the currently selected container type.
    this.bookingContainerTypeSelectTarget.innerHTML = ''
    // 2. show the container type field.
    this.bookingContainerTypeWrapperTarget.classList.remove('hidden')

    const params = {
      booking_id: bookingId,
      at_terminal: true,
      status: 'empty'
    }

    // 3. Fetch the booking details to get the shipping line id
    try {
      const shippingLineId = await this.fetchBookingShippingLineId(bookingId)
      if (shippingLineId) {
        params['shipping_line_id'] = shippingLineId
      }
    } catch (error) {
      console.error("Failed to fetch shipping line from booking details:", error)
    }

    //4. Update the Ajax request params for the container type field with bookingId and shippingLineId.
    this.bookingContainerTypeSelectTarget.dataset.params = JSON.stringify(params)

    // 5. prefill the container type field if there is only one option available.
    this.preFillBookingContainerTypeField(params)
  }

  clearBookingContainerTypeField () {
    if (!this.hasBookingContainerTypeSelectTarget) return;

    // Clear the container type field
    this.bookingContainerTypeSelectTarget.innerHTML = ''
    // Hide the container type field
    this.bookingContainerTypeWrapperTarget.classList.add('hidden')
    // Reset the params for the container type field Ajax request.
    var params = {
      at_terminal: true,
      status: 'empty'
    }
    this.bookingContainerTypeSelectTarget.dataset.params = JSON.stringify(params)
  }

  // Prefill the container type field if there is only one option available.
  preFillBookingContainerTypeField (params) {
    // Build query string for the fetch
    const searchParams = new URLSearchParams(params)
    fetch(`/autocomplete/container_types?${searchParams.toString()}`)
      .then(response => response.json())
      .then(data => {
        if (data.container_types?.length === 1) {
          const option = data.container_types[0]
          // Create and select the option
          const opt = document.createElement("option")
          opt.value = option.id
          opt.text = option.text
          opt.selected = true
          this.bookingContainerTypeSelectTarget.appendChild(opt)

          // Trigger change event so Select2 picks it up
          const event = new Event('change', { bubbles: true })
          this.bookingContainerTypeSelectTarget.dispatchEvent(event)
        }
      })
      .catch(error => {
        console.error("Error fetching container types:", error)
      })
  }

  async fetchBookingShippingLineId(bookingId){
    const response = await fetch(`/truck_visits/truck_gate_in/bookings/${bookingId}.json`)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    return data.booking?.shipping_line?.id
  }

  // Pickup Full Container
  async updateBolContainerTypeField () {
    if (!this.hasBolFieldTarget) return;

    const bolId = this.bolFieldTarget.value
    if (!bolId) {
      this.clearBolContainerTypeField()
      return
    }

    if(!this.hasBolContainerTypeSelectTarget) return;

    // If there is a bol id,
    // 1. clear the the currently selected container type.
    this.bolContainerTypeSelectTarget.innerHTML = ''
    // 2. show the container type field.
    this.bolContainerTypeWrapperTarget.classList.remove('hidden')

    const params = {
      bol_segment_id: bolId,
      at_terminal: true,
      status: 'full'
    }

    //3. Update the Ajax request params for the container type field with bolId
    this.bolContainerTypeSelectTarget.dataset.params = JSON.stringify(params)

    // 4. prefill the container type field if there is only one option available.
    this.preFillBolContainerTypeField(params)
  }

  clearBolContainerTypeField () {
    if (!this.hasBolContainerTypeSelectTarget) return;

    // Clear the container type field
    this.bolContainerTypeSelectTarget.innerHTML = ''
    // Hide the container type field
    this.bolContainerTypeWrapperTarget.classList.add('hidden')
    // Reset the params for the container type field Ajax request.
    var params = {
      at_terminal: true,
      status: 'full'
    }
    this.bolContainerTypeSelectTarget.dataset.params = JSON.stringify(params)
  }

  // Prefill the container type field if there is only one option available.
  preFillBolContainerTypeField (params) {
    // Build query string for the fetch
    const searchParams = new URLSearchParams(params)
    fetch(`/autocomplete/container_types?${searchParams.toString()}`)
      .then(response => response.json())
      .then(data => {
        if (data.container_types?.length === 1) {
          const option = data.container_types[0]
          // Create and select the option
          const opt = document.createElement("option")
          opt.value = option.id
          opt.text = option.text
          opt.selected = true
          this.bolContainerTypeSelectTarget.appendChild(opt)

          // Trigger change event so Select2 picks it up
          const event = new Event('change', { bubbles: true })
          this.bolContainerTypeSelectTarget.dispatchEvent(event)
        }
      })
      .catch(error => {
        console.error("Error fetching container types:", error)
      })
  }
}
